'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var reduce = require('./reduce');
var getInitial = require('../utils/getInitial');
var type = require('../value/type');

var collect = function collect(item, key, value) {
  var itemType = type(item);
  if (itemType === 'array' || itemType === 'string') {
    return item.concat(value);
  }
  return _extends({}, item, _defineProperty({}, key, value));
};

var mapFilter = function mapFilter(item, fn) {
  return reduce(item, function (newItem, value, key, item) {
    var newValue = fn(value, key, item);
    return newValue === undefined ? newItem : collect(newItem, key, newValue);
  }, getInitial(item));
};

module.exports = mapFilter;


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/iterable/mapFilter.js
// module id = 2186
// module chunks = 37